const actions = {
  GET_TRIPLESEAT_SITE: 'GET_TRIPLESEAT_SITE',
  GET_TRIPLESEAT_SITE_REDUCER: 'GET_TRIPLESEAT_SITE_REDUCER',

  getSite: () => ({ type: actions.GET_TRIPLESEAT_SITE }),
};

export default actions;
